<template>
    <div class="charts charts--outer">
        <div class="charts__row">
			<div class="charts__item" v-for="(item,index) in getFirstDays" :key="index">
				<chart-day
					:dayDate="item"
					:switchModeIcon="switchIcon[index]"
					@switchMode="switchMode">
				</chart-day>
			</div>
		</div>
		<div class="charts__row">
			<div class="charts__item" v-for="(item,index) in getLastDays" :key="index">
				<chart-day
					:dayDate="item">
				</chart-day>
			</div>
		</div>
    </div>
</template>
<script>
import PrognosisChart from "../../sig-profitability-chart-prognosis";
import { mapGetters } from "vuex";
import SingleDayChart from "./singleDayChart";
export default {
    components: {
        'chart':PrognosisChart,
        'chart-day':SingleDayChart
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false}
    },
    data() {
        return {
            statistics:null,
            daysStat:null,
            switchIcon:[false, false, true]
        }
    },
    computed: {
        ...mapGetters({
            getStatistics: 'accountstat/getStatistics'
        }),
        getFirstDays() {
            if(this.daysStat === null)
                return
            let firstDays = this.daysStat;
            return firstDays.slice(0,3);
        },
        getLastDays() {
            if(this.daysStat === null)
                return
            let lastDays = this.daysStat;
            return lastDays.slice(3);
        }
    },
    methods: {
        getStat() {
            let stat = this.getStatistics('');
            if (stat.DailyRecords.length === 0)
                return;
            this.statistics = stat;
            this.daysStat = getDay(this.statistics.HourlyRecords);
        },
        switchMode() {
            this.$emit('switchMode');
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            this.getStat()
        });
        this.getStat();
    },
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "profitDay-grid",
            handler: handler
        }
    });
}
function getDay(arr) {
    let result = [];
    nextInput:
        for (let i = 0; i < arr.length; i++) {
            let str = new Date(getOnlyDate(arr[i].Date)).getDate();
            for (let j = 0; j < result.length; j++)
                if (result[j] == str) continue nextInput;
            result.push(str);
        }
    return result;
}
function getOnlyDate(date) {
    let arr = date.split('T');
    let newDate = arr.splice(0, 1);
    return newDate[0];
}
</script>
<style lang="less">

</style>
